<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 4.5H3V6H21V4.5Z" fill="var(--color, #404968)" />
    <path d="M21 18H3V19.5H21V18Z" fill="var(--color, #404968)" />
    <path d="M21 9H3V10.5H21V9Z" fill="var(--color, #404968)" />
    <path d="M21 13.5H3V15H21V13.5Z" fill="var(--color, #404968)" />
  </svg>
</template>
